module.exports = __webpack_public_path__ + "img/horizontal_7_2_9016.8aa40357.png";